import { Controller } from "@hotwired/stimulus"
import html2pdf from 'html2pdf.js'

export default class extends Controller {

  static values = { displayMode: String, successMessage: String, pdfTitle: String, pdfContentDiv: String, divToHide: String }
  static targets = ['trigger']

  selectInputValue(e){
    e.currentTarget.select();
  }

  async convertImageToBase64(imgSrc) {
    if (imgSrc.startsWith('data:')) {
      return Promise.resolve(imgSrc);
    }

    const extension = imgSrc.split('.').pop().split('?')[0].toLowerCase();
    const headers = {
      'Content-Type': `image/${extension}`,
      'Cache-Control': 'no-cache'
    }

    return fetch(imgSrc, { mode: 'cors', headers })
      .then(async (response) => {
        if (!response.ok) {
          return null;
        }

        let data = await response.blob();
        if (!data.type.startsWith('image/')) {
          const extension = imgSrc.split('.').pop().split('?')[0].toLowerCase();
          const types = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', gif: 'image/gif', svg: 'image/svg+xml' };
          data = new Blob([data], { type: types[extension] || 'image/png' });
        }

        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(new Error('Failed to convert image'));
          reader.readAsDataURL(data);
        });
      })
      .catch(e => {
        console.log('Failed to convert image', e);
        return null;
      });
  }

  initialize() {
    this.triggerTarget.addEventListener('click', async (e) => { 
      e.preventDefault()
      
      const pdfTitle = this.pdfTitleValue.toLowerCase().replaceAll(/ /g, '-')
      const content = document.querySelector(this.pdfContentDivValue).cloneNode(true)

      this.divToHideValue.split(',').forEach(div => {
        if (div.includes('>')) {
          const [parent, child] = div.split('>')
          content.querySelector(parent)?.querySelector(child)?.remove()
        } else {
          content.querySelector(div)?.remove()
        }
      })

      const tempContainer = document.createElement('div')
      tempContainer.style.position = 'absolute'
      tempContainer.style.left = '-9999px'
      tempContainer.appendChild(content)
      document.body.appendChild(tempContainer)

      const images = content.querySelectorAll('img')
      for (const img of images) {
        const base64Src = await this.convertImageToBase64(img.src)
        if (base64Src) {
          const oldSrc = img.getAttribute('src') || img.src
          const regex = new RegExp(`(<img[^>]*src=['"])${oldSrc.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')}(['"][^>]*>)`, 'g')
          content.innerHTML = content.innerHTML.replace(regex, `$1${base64Src}$2`)
        } else {
          img.remove()
        }
      }

      const options = {
        margin: [5, 5, 5, 5],
        filename: `${pdfTitle}.pdf`,
        image: { type: 'png', quality: 1 },
        html2canvas: {
          useCORS: true,
          allowTaint: true,
          letterRendering: true
        },
        pagebreak: { before: '.page-break-before', after: '.page-break-after', avoid: ['img', '.no-break'] }
      }

      try {
        return html2pdf().set(options).from(content).outputPdf('datauristring').save()
      } finally {
        document.body.removeChild(tempContainer)
      }
    })
  }
}
